module.exports = __webpack_public_path__ + "img/awards7.21151d4a.svg";